import React, { useState } from 'react';
import styled from '@emotion/styled';
import { BodyTextMedium } from '@modernhealth/vital-components';
import { colors } from '@modernhealth/vital-foundation';

import { ContactUsModal } from 'src/shared/components/ContactUsModal';
import { mediaQueries } from 'src/shared/styles/variables';

export interface Props {
    description: string;
    action: string;
    tags?: string[];
}

enum UiState {
    DEFAULT,
    CONTACT_US_MODAL,
}

export const ProviderSelectionContactUsBanner = ({ description, action, tags }: Props) => {
    const [uiState, setUiState] = useState(UiState.DEFAULT);

    return (
        <>
            <Wrapper>
                <ContentContainer>
                    <BodyTextMedium fontColor="blue85" centered>
                        {description + ' '}
                        <BodyTextMedium
                            bold
                            underline
                            fontColor="blue85"
                            as="span"
                            css={{
                                display: 'inline',
                                cursor: 'pointer',
                            }}
                        >
                            <span
                                role="button"
                                onClick={() => setUiState(UiState.CONTACT_US_MODAL)}
                            >
                                {action}
                            </span>
                        </BodyTextMedium>
                    </BodyTextMedium>
                </ContentContainer>
            </Wrapper>
            <ContactUsModal
                visible={uiState === UiState.CONTACT_US_MODAL}
                onToggle={() => setUiState(UiState.DEFAULT)}
                tags={tags}
                helpDesk
            />
        </>
    );
};

const Wrapper = styled.div({
    padding: '24px',
});

const ContentContainer = styled.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.gray05,
    width: '100%',
    borderRadius: '4px',
    padding: '20px 200px',

    [mediaQueries.lg]: {
        padding: '20px 20px',
    },
});
